import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  panel: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto auto',
    gridGap: '1rem'
  },

  option: {
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
